import { useEffect, useState } from 'react';
import { take } from 'rxjs/operators';
import { TrialDetails } from '../../../core/interfaces/trial-details';
import { TrialDetailsService } from '../../../core/services/trial-details.service';
import useService from '../../../injector/hooks/useService';

export default function useTrialDetails() {
  const [trialDetails, setTrialDetails] = useState<TrialDetails>();
  const trialDetailsService = useService(TrialDetailsService);

  useEffect(() => {
    const trialDetailsSubscription = trialDetailsService.trialDetails$.pipe(
      take(1)
    ).subscribe(setTrialDetails);

    return () => trialDetailsSubscription.unsubscribe();
  }, []);

  return {
    isPaidUser: trialDetails?.isPaidUser(),
    isTrialUser: trialDetails?.isInTrial(),
    trialStatus: trialDetails?.status,
  };
}
